import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import axios from 'axios'
import _ from 'lodash'

import { setModal, unsetModal } from '@/store/slices/modalSlice'
import config from '@/config/config-esm'

const CampaignsComponent = ({ item, subscriptionId, onItemChange }) => {
  const dispatch = useDispatch()
  const user = useSelector((state) => state.user)
  const formData = useSelector((state) => state.formData)
  const layout = useSelector((state) => state.layout)
  
  const [subscriptionCampaigns, setSubscriptionCampaigns] = useState([])

  const getSubscriptionsCampaigns = () => {
    if (!subscriptionId) return
    axios
      .get(`${config.apiUrl}/subscription-campaigns/${subscriptionId}`)
      // axios.get(`${config.apiUrl}/subscriptions/${subscriptionId}/campaigns?active=true`)
      .then((r) => {
        let copy = [...r.data]
        if (layout.data.departmentId) {
          copy = copy.filter(
            (campaign) =>
              (campaign.departmentId &&
                campaign.departmentId === layout.data.departmentId) ||
              !campaign.departmentId,
          )
        }
        setSubscriptionCampaigns(copy)
      })
      .catch((e) => {
        console.log(e)
      })
  }

  useEffect(() => {
    getSubscriptionsCampaigns()
  }, [subscriptionId])

  const toggleCampaign = (e, currentCampaigns) => {
    currentCampaigns = currentCampaigns || []
    if (e.target.checked) {
      // add campaign
      currentCampaigns.push(e.target.value)
    } else {
      currentCampaigns = _.remove(currentCampaigns, (c) => c !== e.target.value)
      // console.log('currentES', currentES)
    }
    return currentCampaigns
  }


  const campaignsAsExtraServices = config.campaignsAsExtraServices.map((c) => c[1])
  const realCampaigns = (subscriptionCampaigns || []).filter(
    (c) => !campaignsAsExtraServices.includes(c.id),
  )
  const activeCampaigns = realCampaigns.filter((sc) => sc.active === true)
  console.log('subscriptionCampaigns', activeCampaigns)
  const { departmentId } = layout?.data || {}
  let campaignMarkup

  if (!item.subscriptionId) {
    campaignMarkup = <p>Velg et abonnement.</p>
  } else {
    campaignMarkup = <p>Ingen tilgjengelige tilbud for abonnementet.</p>
  }

  // Check if there is at least one unlimited subscription
  let hasAtLeastOneUnlimitedSub = false
  formData.phoneItems.forEach((phoneItem) => {
    if (
      config.unlimitedSubscriptionIds.includes(subscriptionId) &&
      formData.bulkInvoiceDiscountActive
    ) {
      hasAtLeastOneUnlimitedSub = true
    }
  })

  let filteredCampaigns = activeCampaigns.filter((c) => {
    return (
      c.id !== config.blackFridayCampaignId &&
      (c.id !== config.u30CampaignId ||
        !(
          config.unlimitedSubscriptionIds.includes(subscriptionId) &&
          formData.bulkInvoiceDiscountActive
        ))
    )
  })

  // XXX: Hardcoded exception to hide "Utkjøpsrabatt" for Network Negatioations
  // if (departmentId === '66e8b506-fa62-4ab7-a68a-58ec9e555876') {
  //   filteredCampaigns = filteredCampaigns.filter(c => c.id !== config.outletDiscountCampaignId)
  // }

  return (
    <div>
      <h1>Velg tilbud</h1>

      {filteredCampaigns.length
        ? filteredCampaigns.map((cmp) => (
            <React.Fragment key={`cmp-${cmp.id}`}>
              <div className="input_wrapper">
                <input
                  type="checkbox"
                  value={cmp.id}
                  id={`cmp-${cmp.id}`}
                  checked={item.campaigns.indexOf(cmp.id) === -1 ? false : true}
                  onChange={(e) => {
                    if (
                      (item.campaigns && item.campaigns.length < 3) ||
                      item.campaigns.indexOf(cmp.id) !== -1
                    ) {
                      const newCampaigns = toggleCampaign(e, item.campaigns)
                      const newItem = { ...item, campaigns: newCampaigns }
                      onItemChange(newItem)
                    } else {
                      dispatch(
                        setModal({
                          show: true,
                          heading: 'Kun to tilbud kan velges.',
                          body: <p>Det er kun mulig å kombinere to tilbud.</p>,
                          button: (
                            <button
                              className="secondary large"
                              onClick={() => dispatch(unsetModal())}
                            >
                              Ok
                            </button>
                          ),
                        }),
                      )
                    }
                  }}
                />
                <label htmlFor={`cmp-${cmp.id}`}>
                  <span>{cmp.name}</span>
                </label>
              </div>
            </React.Fragment>
          ))
        : campaignMarkup}
    </div>
  )
}

export default CampaignsComponent
